export default __webpack_public_path__ + "img/pricing-table.4f3ad2.svg";